import { BLOCK_CLASSES as a } from "../../constants.js";
import { stylable as n } from "../decorators/stylable.js";
import { getBackgroundColor as c } from "./spec-util.js";
const d = ["true", "false"];
let u = (t, e) => e ? t.concat(e, ";") : "", i = (t) => {
  var e, r, s, o, l;
  return {
    paddingTop: (e = t.style) == null ? void 0 : e.paddingTop,
    paddingBottom: (r = t.style) == null ? void 0 : r.paddingBottom,
    paddingLeft: (s = t.style) == null ? void 0 : s.paddingLeft,
    paddingRight: (o = t.style) == null ? void 0 : o.paddingRight,
    backgroundColor: c((l = t.style) == null ? void 0 : l.backgroundColor),
    colwidth: t.getAttribute("data-colwidth") ? [Number(t.getAttribute("data-colwidth"))] : null
  };
};
const y = n({
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  attrs: {
    type: { default: "table" },
    responsive: { default: !1 },
    container: { default: !1 },
    stacked: { default: void 0 },
    sectionType: { default: void 0 }
  },
  parseDOM: [
    {
      tag: "table",
      getAttrs(t) {
        var e;
        return {
          responsive: t.attributes["data-responsive"] !== void 0,
          stacked: d.includes(t.attributes["data-stacked"]) ? t.attributes["data-stacked"] : !0,
          container: t.attributes["data-container"] !== void 0,
          sectionType: t.attributes["data-section-type"] !== void 0 ? t.attributes["data-section-type"].nodeValue : void 0,
          backgroundColor: c((e = t.style) == null ? void 0 : e.backgroundColor)
        };
      }
    }
  ],
  toDOM(t) {
    if (t.attrs.container) {
      let e = t.attrs.sectionType || "";
      return [
        "div",
        {
          class: `${a.blockContainer} ${a.table} embercom-prosemirror-composer-section`
        },
        ["div", { class: "section-type" }, e],
        [
          "table",
          {
            class: "container intercom-template-content",
            "data-container": "true",
            "data-section-type": e,
            style: `${u("background-color: ", t.attrs.backgroundColor)}`
          },
          ["tbody", 0]
        ]
      ];
    }
    return t.attrs.responsive ? [
      "div",
      {
        class: `${a.blockContainer} ${a.table} embercom-prosemirror-composer-layout`
      },
      [
        "table",
        {
          class: "row intercom-responsive-layout-table",
          "data-responsive": "true",
          "data-stacked": typeof t.attrs.stacked == "boolean" ? t.attrs.stacked.toString() : ""
        },
        ["tbody", 0]
      ]
    ] : [
      "div",
      {
        class: `${a.blockContainer} ${a.table}`
      },
      ["table", ["tbody", 0]]
    ];
  }
}), f = {
  content: "tableCell+",
  tableRole: "row",
  parseDOM: [{ tag: "tr" }],
  toDOM() {
    return ["tr", 0];
  }
}, k = n({
  content: "(block | list)+",
  tableRole: "cell",
  isolating: !0,
  parseDOM: [
    {
      tag: "td",
      getAttrs(t) {
        return i(t);
      }
    },
    {
      tag: "th",
      getAttrs(t) {
        return i(t);
      }
    }
  ],
  attrs: {
    colspan: { default: 1 },
    rowspan: { default: 1 },
    colwidth: { default: null },
    responsiveClasses: { default: "" },
    container: { default: !1 }
  },
  toDOM(t) {
    var r;
    return t.attrs.responsiveClasses ? ["td", { "data-insertable": "true", class: t.attrs.responsiveClasses }, 0] : ["td", { "data-insertable": "true", "data-colwidth": (((r = t.attrs.colwidth) == null ? void 0 : r.length) > 0 ? t.attrs.colwidth[0] : null) || void 0 }, 0];
  }
});
export {
  k as tableCellSpec,
  f as tableRowSpec,
  y as tableSpec
};
